import React from 'react'
import {getId} from '../twd'

export default ({
    placeholder="Select",
    multiple=true,
    children
} = {}) => {
    let id = getId()

    return <div className="dropdown" style={{width:'100%'}}>
    <button
        id={id}
        type="button"
        data-toggle="dropdown"
        className="dropdown-toggle form-control text-left text-muted"
        style={{
            borderRadius:0,
            marginBottom: '10px'
        }}>
        <label className="label-large">{placeholder}</label>
        <i className="material-icons" style={{
            position: 'absolute',
            fontSize: '24px',
            right: '5px',
            top: '5px',
        }}>keyboard_arrow_down</i>
    </button>

    <ul className="dropdown-menu"
        role="menu"
        aria-labelledby={id}
        style={{
            backgroundColor:'#fff',
            border: '1px solid #eaeaea'
        }}
    >{multiple ? <form>{children}</form> : children}</ul>
    </div>
}
